export const Data = [
  {
    data: [
      {
        title: "Medical Astrology: Diseases & Astrology",
        description: `Medical Astrology or Ayur Jyotish is an ancient methodology that integrates both the genres of medical science and Vedic Astrology. Predictions are based on the position and influence of various planets, zodiac signs and Nakshatras. It takes years of anatomical expertise and astrological knowledge to qualify this genre and attain qualitative proficiency in forecasting diseases and providing remedies to cure illness.
            
Medical Astrology provides an insight regarding any cosmic influence in the birth chart to one’s health and whether or not it will be disadvantageous or favorable. You can evaluate the following factors: Severity of the illness, probable duration, probable, outcome, and additional remedies and suggestions to cure the disease.

A medical astrologer examines a person’s birth chart, explores the position of signs and planets and predicts illnesses and diseases, if any. Hence, one gets to know about advancing health disorders such as Diabetes, Blood Pressure, Heart Disease, Breathing disorders etc. in future and can take necessary actions.

At Astrolive, we believe in providing forecasts to our readers about how to tackle several health-related situations and what remedies must be followed to cure your body.`,
      },
    ],
  },
];
